import { Component, OnInit, Type } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DashbordService } from '../../Services/DashbordServices';
import { CheckAuth } from '../../Services/UtilityService';
import { LoginComponent } from '../login/login.component';
import { UserMasterModel } from '../../Models/UserMasterModel';
import { PlanDocumentModel } from '../../Models/PlanDocumentModel';
import { UserDocumentModel } from '../../Models/UserDocumentModel';
import { PlanModel } from '../../Models/PlanModel';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'Dashboard',
  templateUrl: './Dashboard.component.html'
})
export class DashboardComponent {
  tokenKey: string = "";
  userID: number;
  successMessage: any;
  isshowsuccess: boolean;
  errorMessage: any;
  isshowmore: boolean;
  isshowerror: boolean;
  isShowprogressSpinner: boolean;
  blockedPanel: boolean = false;
  blockedDocument: boolean = false;
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showerror(msg) {
    this.errorMessage = msg;
    this.isshowerror = true;
    this.isshowsuccess = false;
    window.scrollTo(0, 0);
  }
  hideerror() {
    this.errorMessage = "";
    this.isshowerror = false;
  }
  showsuccess(msg) {
    this.successMessage = msg;
    this.isshowsuccess = true;
    this.isshowerror = false;
    window.scrollTo(0, 0);
  }
  value: number = 0;

  userinfo: UserMasterModel = {
    userId: 0,
    lastLogin: '',
    lastUpdate: '',
    lastUpdatedDoc: '',
    lastVisitPlan: '',
    lastVisitedPlan: ''
  };
  plandocuments: PlanDocumentModel[];
  planStatistics: PlanStatisticsModel[];
  userdocuments: UserDocumentModel[];
  recentplan: PlanModel[];
  data: any;
  options: any;
  pieChartData: any;
  deleteplanId: number;

  constructor(private router: Router, private DashbordService: DashbordService, private checkAuth: CheckAuth, private logincomp: LoginComponent) {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this.userID = +this.logincomp.GetplainText(sessionStorage.getItem('UserId'));
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.isshowerror = false;
    this.isShowprogressSpinner = false;
    this.unblockDocument();
    this.GetUserInformation();
  }

  GetUserInformation(): void {
    debugger;
    this.DashbordService.GetUserInformationbyid(this.tokenKey, this.userID).subscribe(
      data => {
        debugger;
        if (data["status"] == "Success") {
          if (data["userMaster"].length > 0 && data["userMaster"] != undefined) {
            this.userinfo = data["userMaster"][0];
          } else {
            this.userinfo.userId = 0;
            this.userinfo.lastLogin = "";
            this.userinfo.lastUpdatedDoc = "";
            this.userinfo.lastVisitPlan = "";
            this.userinfo.lastVisitedPlan = "";
          }
        }
        else {
          this.showerror(data["message"]);
          this.unblockDocument();
        }
        this.GetPlanDocumentStatistics();
      },
      errorCode => {
        this.showerror(errorCode);
        this.unblockDocument();
      }
    );
  }

  GetPlanDocumentStatistics(): void {
    this.DashbordService.GetPlanDocumentStatistics(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["status"] == "Success") {
          if (data["planDocument"].length > 0 && data["planDocument"] != undefined) {
            this.plandocuments = data["planDocument"];
            let sefplan = [];
            let envplan = [];
            let mixplan = [];
            for (let i = 0; i < data["planDocument"].length; i++) {
              if (data["planDocument"][i].type === 30) {
                sefplan.push(data["planDocument"][i].planId);
              }
              if (data["planDocument"][i].type === 31) {
                envplan.push(data["planDocument"][i].planId);
              }
            }
            mixplan = sefplan.filter(function (v) {
              return envplan.indexOf(v) > -1;
            });
            for (let i = 0; i < mixplan.length; i++) {
              const index: number = sefplan.indexOf(mixplan[i]);
              if (index !== -1) {
                sefplan.splice(index, 1);
              }
              const index1: number = envplan.indexOf(mixplan[i]);
              if (index1 !== -1) {
                envplan.splice(index1, 1);
              }
            }
            this.planStatistics = [{ Type: 'Environmental Plans', Count: envplan.length }];
            this.planStatistics.push({ Type: 'Safety Plans', Count: sefplan.length });
            this.planStatistics.push({ Type: 'Enviro & Safety Mixed Plans', Count: mixplan.length });
          } else {
            this.planStatistics = [{ Type: 'Environmental Plans', Count: 0 }];
            this.planStatistics.push({ Type: 'Safety Plans', Count: 0 });
            this.planStatistics.push({ Type: 'Enviro & Safety Mixed Plans', Count: 0 });
          }
        }
        else {
          this.planStatistics = [{ Type: 'Environmental Plans', Count: 0 }];
          this.planStatistics.push({ Type: 'Safety Plans', Count: 0 });
          this.planStatistics.push({ Type: 'Enviro & Safety Mixed Plans', Count: 0 });
          this.showerror(data["message"]);
          this.unblockDocument();
        }
        this.GetUserRecentDocument();
      },
      errorCode => {
        this.showerror(errorCode);
        this.unblockDocument();
      }
    );
  }

  GetUserRecentDocument(): void {
    this.DashbordService.GetUserDocumentbyid(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["status"] == "Success") {
          if (data["userDocument"].length > 0 && data["userDocument"] != undefined) {
            this.userdocuments = data["userDocument"];
            if (data["userDocument"].length > 5) {
              this.isshowmore = true;
            }
            else {
              this.isshowmore = false;
            }
          }
        }
        else {
          this.showerror(data["message"]);
          this.unblockDocument();
        }
        this.GetRecentPlan(true);
      },
      errorCode => {
        this.showerror(errorCode);
        this.unblockDocument();
      }
    );
  }

  GetRecentPlan(isload: boolean): void {
    this.DashbordService.GetRecentPlanbyid(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["status"] == "Success") {
          if (data["recentPlan"].length > 0 && data["recentPlan"] != undefined) {
            this.recentplan = data["recentPlan"];
          }
        }
        else {
          this.showerror(data["message"]);
          this.unblockDocument();
        }
        if (isload) {
          this.LoadChart();
        }
      },
      errorCode => {
        this.showerror(errorCode);
        this.unblockDocument();
      }
    );
  }

  LoadChart(): void {
    let chartdata = [[]];
    chartdata = [['Status', 'Count']];
    this.DashbordService.PlanChartbyUserid(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["status"] == "Success") {
          if (data["planChart"].length > 0 && data["planChart"] != undefined) {
            this.GenerateChart(chartdata);
            for (let i = 0; i < data["planChart"].length; i++) {
              chartdata.push([data["planChart"][i].statusName, data["planChart"][i].count]);
            }
          }
          else {
            this.GenerateChart(chartdata);
          }
        }
        else {
          this.showerror(data["message"]);
          this.unblockDocument();
        }
      },
      errorCode => {
        this.showerror(errorCode);
        this.unblockDocument();
      }
    );
  }

  GenerateChart(chartdata: any): void {
    this.pieChartData = {
      chartType: 'PieChart',
      dataTable: chartdata
      , options: {
        'title': '',
        'height': 280,
        annotations: {
          // remove annotation stem and push to middle of chart
          stem: {
            color: 'transparent',
            length: 120
          },
          textStyle: {
            color: '#9E9E9E',
            fontSize: 18
          }
        },
      },
    };
  }

  Removeplan(planId) {
    if (planId > 0) {
      this.deleteplanId = planId;
    }
    if (planId == undefined) {
      this.blockDocument();
      this.DashbordService.DeletePlan(this.tokenKey, this.deleteplanId).subscribe(
        data => {
          if (data["status"] == "Success") {
            this.deleteplanId = 0;
            this.showsuccess("Plan deleted successfully");
            this.GetRecentPlan(false);
            this.unblockDocument();
          }
          else {
            this.showerror(data["message"]);
            this.unblockDocument();
          }
        },
        errorCode => {
          this.showerror(errorCode);
          this.unblockDocument();
        }
      );
    }
  }
}

export class PlanStatisticsModel { Type: string; Count: number; }
